import Modal from "../../../components/modals/Modal";
import { formatearFecha, formatearHora } from "./buscarTurnoHelpers";

// Modal de confirmacion previo a reservar. Presentacional: recibe el turno y
// los callbacks; el orquestador maneja la reserva.
const ConfirmarReserva = ({ turno, error, reservando, onCancelar, onConfirmar }) => (
    <Modal title="Confirmar reserva" onClose={() => { if (!reservando) onCancelar(); }}>
        <div className="modal-form">
            <p className="modal-confirm__text">
                ¿Confirmás la reserva del turno con <strong>{turno.medicoNombre}</strong>?
            </p>
            <div className="modal-confirm__details">
                <p><strong>Fecha:</strong> {formatearFecha(turno.fechaHora)}</p>
                <p><strong>Hora:</strong> {formatearHora(turno.fechaHora)}</p>
                <p><strong>Sede:</strong> {turno.sedeNombre}</p>
            </div>
            {error && <div className="patient-state patient-state--error" role="alert">{error}</div>}
            <div className="modal-form__actions">
                <button type="button" className="btn-ghost" onClick={onCancelar} disabled={reservando}>
                    Cancelar
                </button>
                <button type="button" className="primary-button" onClick={onConfirmar} disabled={reservando}>
                    {reservando ? "Reservando..." : "Confirmar reserva"}
                </button>
            </div>
        </div>
    </Modal>
);

export default ConfirmarReserva;
